
import { Card, CardContent, CardDescription, CardHeader } from "@/components/ui/card";
import { Logo } from "@/components/ui/Logo";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";

const ResetPassword = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-teal to-brand-coral dark:from-brand-teal/90 dark:to-brand-coral/90 py-8">
      <div className="w-full max-w-lg px-4 flex justify-center items-center">
        <Card className="shadow-xl border-0 backdrop-blur-sm bg-white/95 dark:bg-gray-900/95 w-full">
          <CardHeader className="space-y-4 text-center pb-6 pt-8">
            <div className="mx-auto">
              <Logo size="lg" clickable={true} />
            </div>
            <CardDescription className="text-gray-600 dark:text-gray-300 text-base text-center">
              Recupere o acesso à sua conta
            </CardDescription>
          </CardHeader>
          <CardContent className="pb-8 px-6">
            <ResetPasswordForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

// This property tells the app not to use the global layout for this page
ResetPassword.getLayout = (page: React.ReactNode) => page;

export default ResetPassword;
